import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export type AdresseType = 'livraison' | 'facturation' | 'livraison et facturation';

export interface Adresse {
  id: number;
  nom: string;
  prenom?: string;
  service?: string;
  raison_sociale?: string;
  email?: string;
  telephone?: string;
  adresse?: string;
  code_postal?: string;
  ville?: string;
  pays?: string;
  type_adresse: AdresseType;
  client_id: number;
}

export interface AdressePayload {
  nom: string;
  prenom?: string;
  service?: string;
  raison_sociale?: string;
  email?: string;
  telephone?: string;
  adresse?: string;
  code_postal?: string;
  ville?: string;
  pays?: string;
  type_adresse: AdresseType;
  client_id: number;
}

@Injectable({ providedIn: 'root' })
export class AdressesService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/adresses`;

  constructor(private http: HttpClient) {}

  list(): Observable<Adresse[]> {
    return this.http.get<{ items: Adresse[] }>(this.baseUrl).pipe(map(res => res.items));
  }

  get(id: number): Observable<Adresse> {
    return this.http.get<Adresse>(`${this.baseUrl}/${id}`);
  }

  create(payload: AdressePayload): Observable<Adresse> {
    return this.http.post<Adresse>(this.baseUrl, payload);
  }

  update(id: number, payload: AdressePayload): Observable<Adresse> {
    return this.http.put<Adresse>(`${this.baseUrl}/${id}`, payload);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
